<template>
  <div>
    <Calendar
      :items="availability"
      :selected="selectedSlots"
      :timezone="preferedLocale"
      :calendar-error="calendarError"
      :is-loading="isLoading"
      @onRefreshData="$emit('onRefreshData')"
      @onClickCell="(value) => $emit('onClickCell', value)"
    />
    <client-only>
      <div>
        <button
          v-if="!isLoading"
          key="button-timezone"
          class="flex items-center justify-center text-gray-500 focus:outline-none rounded-xl py-1 px-2 ml-auto text-sm font-medium mt-1"
          @click="isModalOpen = true"
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="fill-current mr-2"
          >
            <path
              d="M3.045 9.75C3.18254 10.8419 3.61771 11.8748 4.30291 12.736C4.98811 13.5971 5.89695 14.2532 6.93 14.6325C6.33377 13.0733 6.02381 11.4193 6.015 9.75H3.045ZM3.045 8.25H6.015C6.02381 6.58071 6.33377 4.92671 6.93 3.3675C5.89695 3.74679 4.98811 4.40289 4.30291 5.26402C3.61771 6.12516 3.18254 7.15815 3.045 8.25ZM14.955 8.25C14.8175 7.15815 14.3823 6.12516 13.6971 5.26402C13.0119 4.40289 12.1031 3.74679 11.07 3.3675C11.6662 4.92671 11.9762 6.58071 11.985 8.25H14.955ZM14.955 9.75H11.985C11.9762 11.4193 11.6662 13.0733 11.07 14.6325C12.1031 14.2532 13.0119 13.5971 13.6971 12.736C14.3823 11.8748 14.8175 10.8419 14.955 9.75ZM7.515 9.75C7.635 12.7125 8.4375 15 9 15C9.5625 15 10.365 12.7125 10.485 9.75H7.515ZM7.515 8.25H10.485C10.365 5.2875 9.5625 3 9 3C8.4375 3 7.635 5.2875 7.515 8.25ZM9 16.5C7.01088 16.5 5.10322 15.7098 3.6967 14.3033C2.29018 12.8968 1.5 10.9891 1.5 9C1.5 7.01088 2.29018 5.10322 3.6967 3.6967C5.10322 2.29018 7.01088 1.5 9 1.5C10.9891 1.5 12.8968 2.29018 14.3033 3.6967C15.7098 5.10322 16.5 7.01088 16.5 9C16.5 10.9891 15.7098 12.8968 14.3033 14.3033C12.8968 15.7098 10.9891 16.5 9 16.5Z"
            />
          </svg>
          {{ formattedTimzone }}
        </button>
      </div>

      <ModalContent
        :open="isModalOpen"
        :title="'Change the displayed time'"
        allow-overflow
        @close="isModalOpen = false"
      >
        <div>
          <p class="text-xs text-black font-medium">Your timezone</p>
          <p class="text-sm text-gray-600 mt-2">
            We selected by default the timezone of your browser. Change it as
            you like.
          </p>
        </div>
        <InputTimezone
          key="input-timezone"
          class="mt-8 z-20 max-w-lg relative"
          :timezone="selectedTimezone"
          @onUpdate="onInputTimezoneUpdate"
        />
      </ModalContent>
    </client-only>
  </div>
</template>

<script>
import { getBrowserTimezone } from '~/helpers';
import InputTimezone from '~/components/input/InputTimezone';
import Calendar from '~/components/calendar/Calendar';

export default {
  components: {
    Calendar,
    InputTimezone,
    ModalContent: () => import('~/components/modal/ModalContent')
  },

  props: {
    timezone: {
      type: String,
      default: null,
      required: false
    },
    calendarError: {
      type: String,
      default: null,
      required: false
    },
    availability: {
      type: Array,
      default: null,
      required: false
    },
    selectedSlots: {
      type: Array,
      default: null,
      required: false
    },
    isLoading: {
      type: Boolean,
      default: null,
      required: false
    }
  },

  data() {
    return {
      isModalOpen: false,
      selectedTimezone: null
    };
  },

  computed: {
    preferedLocale() {
      return this.selectedTimezone?.utc?.[0] || 'Europe/Paris';
    },

    formattedTimzone() {
      if (this.selectedTimezone?.text) {
        const splitted = this.selectedTimezone.text.match(/\(([^)]+)\)/);
        return splitted?.[1] || '';
      }
      return 'UTC+01:00';
    }
  },

  mounted() {
    if (!process.browser) {
      return;
    }
    // get the browser timezone
    if (Intl && Intl.DateTimeFormat) {
      const match = getBrowserTimezone();
      this.selectedTimezone = match;
    }
    this.locale = navigator?.languages?.[0] || 'en-US';
  },

  methods: {
    onInputTimezoneUpdate(value) {
      this.selectedTimezone = value;
      this.isModalOpen = false;
    }
  }
};
</script>

<style lang="postcss" scoped></style>
